import { render } from "./AppToolbar.vue?vue&type=template&id=5822a392&ts=true"
import script from "./AppToolbar.vue?vue&type=script&lang=ts"
export * from "./AppToolbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/app-structure/AppToolbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5822a392"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5822a392', __exports__)) {
    api.reload('5822a392', __exports__)
  }
  
  module.hot.accept("./AppToolbar.vue?vue&type=template&id=5822a392&ts=true", () => {
    api.rerender('5822a392', render)
  })

}


export default __exports__